module.exports = __webpack_public_path__ + "static/img/seisankun-description2.28d75bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/seisankun-description2.png
// module id = Bk/o
// module chunks = 1